import * as React from "react"
import { Link } from "react-router-dom"
import {NavigationBar, Layout} from "./layout"
import Table from "react-bootstrap/Table";
import { Typography } from "@mui/material";
import { isMobile } from "./mobile"

const Livestream = () => {


  return (
<>
<NavigationBar/>
{/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{gridArea: "1/1"}}
    layout="fullWidth"
    aspectRatio={3 / 1}
    src="/livestreamBanner.jpg" />
  <div
    style={{gridArea: "1/1",position: "relative",placeItems: "center",display: "grid",}} />
</div>
{/* Main Content */}
<Layout>
  <Typography variant="h1" style={{textAlign:"center"}}>直播時間安排</Typography>
  <br/>
  <Typography variant="h2" style={{textAlign:"center"}}>太平洋標準時間</Typography>
  <br/>

  <Table style={{tableLayout: "fixed"}}><tbody>
    <tr>
      {isMobile? <></> : <td/>}
      <td colSpan={2}>
        <Typography variant="body1">
          星期五<br/>
          亞洲永化法師禪修課, 加州夏時製 下午5點/韓國 週六早上9點<br/>
          亞洲禪修開示，加州夏時製 下午6點/韓國 週六早上10點<br/>
          華嚴經疏講座 加州夏時製 晚上8:30/韓國 週六下午12:30<br/>
          <br/>
          星期六<br/>
          早上9:00 - 10:00 靜坐/禪修基礎課<br/>
          早上10:00 - 11:00 禪修開示<br/>
          早上11:00 - 12:00 素食午餐<br/>
          下午12:30 - 2:30 六祖壇經講座<br/>
          <br/>
          星期日<br/>
          早上8:00 - 香讚，阿彌陀經<br/>
          早上9:40 - 講法<br/>
          早上10:20 - 午齋上供<br/>
          早上11:00 - 12:00 素食午餐<br/>
          下午12:30 - 2:30 華嚴經講座<br/>
          <br/>
          所有道場都遵照這個時間表<br/>
          <br/>
          <b>同時全球在線直播。</b><br/><a href="https://www.youtube.com/c/MasterYongHua/live">https://www.youtube.com/c/MasterYongHua/live</a><br/>
          <br/>
          在佛七和禪七期間，講法的時間改到晚上<br/>
          <br/>
        </Typography>
      </td>
      {isMobile? <></> : <td/>}
    </tr>
    <tr>
      {isMobile? <></> : <td/>}
      <td colSpan={2}>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/9kqQG8GYymU?si=0Khk5vzCh1FQrItJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </td>
      {isMobile? <></> : <td/>}
    </tr>
  </tbody></Table>
  <Typography variant="h1">Youtube聊天規則</Typography>
  <Typography variant="body1">
    🙏 歡迎.<br/>
    <br/>
    當聽法的時候，在我們的意識當中種下法的種子是很重要的。這意味著你不應該試圖理解師父說的每句話。這些內容會自然而然沉澱下來。<br/>
    <br/>
    你最好（但不是必須）坐雙盤聽法。如果你不能做到，可以盡可能堅持。最好不要搖動。<br/>
    <br/>
    讓你的疑問得到解答是修行的重要部分，你可以隨意問問題。因為時間關係，我們優先挑選和講法內容有關的問題和評論。常見問題(FAQ)和沒有回答的問題在常見問題頁面上可以看到。沒有回答的問題會經過審核，審核通過的問題會在以後被提出。如果你有問題我們沒有解決，你可以通過郵件提問，我們的郵箱是info@chanpureland.org。<br/>
    <br/>
    禪七時間表（太平洋時間）：49天禪七期間每晚有講法。<br/>
    <ul>
      <li>周中 (晚上 8:30-9:30)</li>
      <ul>
        <li>百日禪 (週一至週四) 在Rosemead溈山寺 (Wei Mountain Temple)</li>
        <li>禪修開示 (週五) 在聖何塞金林寺</li>
      </ul>
      <li>週末 (晚上 7:20-9:20) 六祖壇經講座在Rosemead溈山寺</li>
    </ul>
    <br/>
    平時時間表（太平洋時間）：<br/>
    <ul>
      <li>週六禪修開示 （早上10-11點）</li>
      <li>週日講法（大概早上9:30-10:30）</li>
      <ul>
        <li>講法一般在法會以後開始，如果有延遲我們表示歉意。</li>
      </ul>
      <li>周日講經 （下午12:30-2:30）</li>
    </ul>
  </Typography>
  <br/>
  <Typography variant="h2">相關鏈接</Typography>
  <Typography variant="body1">
    <a href="https://workflowy.com/s/qa/yvEvcNdL3lODzjf2"><b>Frequently Asked Questions (FAQ)</b></a><br/>
    <a href="https://workflowy.com/s/outstanding-question/gOPtPRGWaadAmHYB"><b>Outstanding Questions</b></a><br/>
    <a href="https://workflowy.com/s/faqs/8w3iHcdgLzZTNLHq"><b>Buddhist Terminology</b></a><br/>
  </Typography>
</Layout>
</>
)
  }

export default Livestream;
